import { Grid, Typography } from '@mui/material';
import {
  SparkTextField,
  SparkDropdown,
  SparkForm,
} from 'sharedComponents/SparkForm';
import { useCountries } from 'hooks/Countries/useCountries';
import { useIndustries } from 'hooks/BusinessIndustries/useIndustries';
import * as yup from 'yup';
import FieldSkeleton from 'sharedComponents/Skeleton/FieldSkeleton';
import Footer from './Footer';

export type CompanyBasicInfoFromValues = {
  companyName: string;
  countryID: string;
  industryID: string;
  coreOffering: string;
};

const companyBasicInfoFromValidationSchema = yup.object({
  companyName: yup.string().required('Required'),
  countryID: yup.string().required('Required'),
  industryID: yup.string().required('Required'),
  coreOffering: yup.string().required('Required'),
});
type CompanyBasicInfoFromProps = {
  shouldRenderWelcomeText?: boolean;
  activeStep: number;
  nextStepHandler: () => void;
  basicInfoCollection?: CompanyBasicInfoFromValues;
  setBasicInfoCollection: (formValues: CompanyBasicInfoFromValues) => void;
  previousStepHandler: () => void;
};

function CompanyBasicInfoFrom({
  shouldRenderWelcomeText = false,
  activeStep,
  nextStepHandler,
  setBasicInfoCollection,
  basicInfoCollection,
  previousStepHandler,
}: CompanyBasicInfoFromProps) {
  const { dropdownOptions: countries, isLoading: isLoadingCountries } =
    useCountries();
  const { dropdownOptions: industries, isLoading: isLoadingIndustries } =
    useIndustries();
  const isLoading = isLoadingCountries || isLoadingIndustries;

  const companyBasicInfoFromInitialValues = {
    companyName: basicInfoCollection?.companyName || '',
    countryID: basicInfoCollection?.countryID || '',
    industryID: basicInfoCollection?.industryID || '',
    coreOffering: basicInfoCollection?.coreOffering || '',
  };
  const handleSubmit = (values: CompanyBasicInfoFromValues) => {
    setBasicInfoCollection(values);
    nextStepHandler();
  };
  if (isLoading) {
    return <FieldSkeleton count={4} />;
  }

  return (
    <SparkForm
      initialValues={companyBasicInfoFromInitialValues}
      validationSchema={companyBasicInfoFromValidationSchema}
      onSave={handleSubmit}
    >
      <Grid item padding={2} paddingLeft={0}>
        <Typography
          fontFamily='Mont-regular'
          justifyContent='flex-start'
          sx={{ fontSize: '1.0rem' }}
          color='nightblack'
        >
          Help us better understand your company & unique needs.
        </Typography>
      </Grid>

      <Grid container marginTop={2}>
        <SparkTextField
          name='companyName'
          label='Company Name'
          size={12}
          placeholder='Enter Company Name'
        />

        <SparkDropdown
          name='countryID'
          label='Country'
          size={12}
          children={[...countries]}
        />

        <SparkDropdown
          name='industryID'
          label='Industry'
          size={12}
          children={[...industries]}
        />
        <SparkTextField
          name='coreOffering'
          label='Core Offering'
          size={12}
          placeholder='e.g. Interactive online wellness platform.'
          helpText='Briefly describe your main product or service in one sentence'
        />
      </Grid>
      <Footer
        activeStep={activeStep}
        isLastStep={false}
        handleBack={previousStepHandler}
      />
    </SparkForm>
  );
}

export default CompanyBasicInfoFrom;
